import { render, staticRenderFns } from "./CtrlMenuAddress.vue?vue&type=template&id=6c77c0c4&"
import script from "./CtrlMenuAddress.vue?vue&type=script&lang=ts&"
export * from "./CtrlMenuAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports